module.exports = __webpack_public_path__ + "img/set-item2.1610b58b.png";